import React, { Fragment, useRef, useContext, useState } from 'react';
import Slider from 'react-slick';

import useCarouselStyles, { importSlickStyles } from './styles';

import ArrowButton from '../../components/arrowButton';
import PageContext from '../../contexts/pageContext';

function dotsToShow(i, n) {
  const elementsToShow = 5;
  const leftToShow = i < elementsToShow / 2;
  const rightToShow = n - i - 1 < elementsToShow / 2;
  let leftCount, rightCount;

  if (leftToShow) {
    leftCount = i;
    rightCount = elementsToShow - i - 1;
  } else if (rightToShow) {
    leftCount = elementsToShow - (n - i);
    rightCount = n - i - 1;
  } else {
    leftCount = 2;
    rightCount = 2;
  }

  return { leftCount, rightCount };
}

export default function Carousel({
  settings,
  children,
  hideArrow,
  buttonContainerClass,
  inverted
}) {
  importSlickStyles();
  const sliderRef = useRef();
  const { isMobile } = useContext(PageContext);
  const classes = useCarouselStyles({
    isMobile,
    buttonContainerClass,
    inverted
  });
  const [currentDot, setCurrentDot] = useState(0);

  const sliderSettings = {
    dots: isMobile,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (prev, next) => {
      setCurrentDot(Math.ceil(next));
    },
    appendDots: (dots) => {
      const { leftCount, rightCount } = dotsToShow(currentDot, children.length);
      return (
        <div>
          <ul>
            {dots.map((item, i) => {
              if (currentDot - leftCount <= i && currentDot + rightCount >= i)
                return <li key={i}>{item.props.children}</li>;
              else return <Fragment key={i} />;
            })}
          </ul>
        </div>
      );
    },

    customPaging: (i) => {
      const { leftCount, rightCount } = dotsToShow(currentDot, children.length);
      if (currentDot - leftCount <= i && currentDot + rightCount >= i)
        return (
          <div
            className={i == currentDot ? classes.activeDot : classes.dots}
          ></div>
        );
      else return <></>;
    },
    ...settings,
    className: settings?.className
      ? settings?.className + ' ' + classes.sliderClass
      : classes.sliderClass
  };

  const nextClick = () => {
    sliderRef.current.slickNext();
  };
  const previousClick = () => {
    sliderRef.current.slickPrev();
  };
  return (
    <>
      <Slider ref={sliderRef} {...sliderSettings}>
        {children}
      </Slider>
      {hideArrow || isMobile ? null : (
        <div className={buttonContainerClass || classes.buttonContainer}>
          <ArrowButton onClick={previousClick} left inverted={inverted} />
          <ArrowButton onClick={nextClick} right inverted={inverted} />
        </div>
      )}
    </>
  );
}
